// extracted by mini-css-extract-plugin
module.exports = {"campaignResultsTable":"CampaignSummary_campaignResultsTable__2r_4v","tabs":"CampaignSummary_tabs__3yMBn"};